module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-UltraLight.30111f49.ttf";